import styled from 'styled-components'

import { Box, Icon, Text } from '@redriverpress/system'
import Button from './Button'

const IconBox = styled(Box).attrs(() => ({
  bg: 'white',
  color: 'black',
  display: 'flex', // will allow for different icon & logo widths when we use this for generalized SSO buttons
  width: 'calc(3rem - 2px)', // width matches width of icons in inputs so they look a nice when stacked
  alignItems: 'center',
  justifyContent: 'center',
  my: 'calc(-1rem + 2px)', // offset for button padding and allowing for an 'border'
  ml: 'calc(-2rem + 2px)', // offset for button padding and allowing for an 'border'
}))`
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
`

export default function SSOButton({ children, icon, ...props }) {
  return (
    <Button display='flex' {...props}>
      <IconBox>
        {typeof icon === 'string' ? <Icon icon={icon} weight='brands' /> : icon}
      </IconBox>
      {/* negative margin right offsets padding of button */}
      {/* padding on text prevents the text from squishing on either side */}
      <Text as='span' flex='1' textAlign='center' mr={-4} px={3}>
        {children}
      </Text>
    </Button>
  )
}
